
















































import { Component, Vue } from "vue-property-decorator";
import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { IHotelInfo } from "@/@types/hotel-info/info";
import { hotelInfo } from "@/config/host.config";
import { preferred_language } from "@/config/languags.config.json";

import FullHotelInfoRecyclerList from "@/components/tables/hotel-info/full-hotel-info-recycler-list.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import HotelInfoDemo from "@/components/demo/hotel-info/hotel-info-demo.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import MainDemo from "@/components/demo/main-demo.vue";

@Component({
  components: {
    FullHotelInfoRecyclerList,
    InputSearch,
    ButtonBack,
    MainDemo,
    HotelInfoDemo,
    LanguagesButtons,
  },
})
export default class HotelInfoRecucker extends Vue {
  locale = preferred_language;
  infoList: Array<IHotelInfo> = [];
  idDemo = "";
  search = "";

  get demo(): IHotelInfo | null {
    const demo = this.infoList.find((el) => el._id == this.idDemo);
    return demo ? demo : null;
  }

  get infos(): Array<IHotelInfo> {
    return this.infoList.filter((item: IHotelInfo) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  async restore(id: string | undefined): Promise<void> {
    if (!id) return;
    try {
      const uri = `${hotelInfo.restore}/${id}`;
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.deleteElement(id);
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  deleteElement(id: string): void {
    for (let i = 0; i < this.infoList.length; i++) {
      if (id == this.infoList[i]._id) {
        this.infoList.splice(i, 1);
        this.$emit("createList");
        return;
      }
    }
  }

  async getHotelInformation(): Promise<Array<IHotelInfo>> {
    const uri = hotelInfo.mainAPI;
    const config: AxiosRequestConfig = {
      params: { "match[deleted][value]": true },
    };
    return new Promise<Array<IHotelInfo>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((infoRes: AxiosResponse<Array<IHotelInfo>>) => {
          if (infoRes.status === 200) res(infoRes.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  startCreateHotelInfoList(): void {
    this.getHotelInformation()
      .then((info: Array<IHotelInfo>) => {
        this.infoList = info;
      })
      .catch((e: AxiosError) => console.log(e));
  }

  mounted(): void {
    this.startCreateHotelInfoList();
  }
}
